var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-tag"},[_c('div',{staticClass:"name"},[_vm._t("default")],2),_vm._v(" "),_c('SvgIcon',{attrs:{"name":"common#icon_navigation_close_xxs","size":"12"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }